import { InventoryRemoveFormik } from '../InventoryRemoveFormik';
import { QuantityGetDto } from 'svila-common/types/back-end/QuantityGetDto';
import { RemoveStockTransactionAddDto } from '../RemoveStockTransactionAddDto';
import { quantityGetDtoToStockTransactionAddDto } from './quantityGetDtoToStockTransactionAddDto';
import { RemoveFormDto } from '../RemoveFormDto';

export const formikValuesAndItemToRemoveStockTransaction = (
  values: InventoryRemoveFormik,
  template: QuantityGetDto
): RemoveStockTransactionAddDto => ({
  formData: {
    singleCuUnits: Number(values.singleCuUnits),
    singleDpUnits: Number(values.singleDpUnits),
    fullDuUnits: Number(values.fullDuUnits),
  } as RemoveFormDto,
  templateData: quantityGetDtoToStockTransactionAddDto(template),
});